import { render, staticRenderFns } from "./ModalEntregaGeral.vue?vue&type=template&id=299066b4"
import script from "./ModalEntregaGeral.vue?vue&type=script&lang=js"
export * from "./ModalEntregaGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports